<template>
    <div>
        <div class="mb-3">
            <label class="form-label">Tarix</label>
            <el-date-picker v-model="form.expenseDate" size="large" type="date" placeholder="Seçin" style="width: 100%;"
                format="DD.MM.YYYY" />
        </div>
        <div class="mb-3">
            <label class="form-label">Səbəb</label>
            <el-select v-model="form.reasonId" size="large" placeholder="Seçin" style="width: 100%;">
                <el-option v-for="reason in reasonList" :key="reason.id" :label="reason.name" :value="reason.id" />
            </el-select>
        </div>
        <div class="mb-3">
            <label class="form-label">Məbləğ</label>
            <el-input v-model.number="form.amount" size="large" type="number" placeholder="Məbləğ" />
        </div>
        <div class="mb-3">
            <label class="form-label">Qeyd</label>
            <el-input v-model="form.note" type="textarea" size="large" placeholder="Əlavə qeyd" :rows="3" />
        </div>
        <div class="d-flex justify-content-end mt-4">
            <soft-button type="button" @click="save">Yadda saxla</soft-button>
            &nbsp;&nbsp;
            <soft-button type="button" color="secondary" @click="resetForm(); $emit('cancel')">İmtina</soft-button>
        </div>
    </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import { CreateCourtExpense, UpdateCourtExpense } from "@/project/Source/expenses";

export default {
    components: { SoftButton },
    props: {
        expenseToEdit: { type: Object, default: null },
        reasonList: { type: Array, required: true },
        courtCaseId: { type: Number, required: true }
    },
    data() {
        return {
            form: {
                expenseDate: "",
                reasonId: null,
                amount: null,
                note: ""
            }
        };
    },
    watch: {
        expenseToEdit: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.form = {
                        expenseDate: newVal.expenseDate ? new Date(newVal.expenseDate) : "",
                        reasonId: newVal.reasonId,
                        amount: newVal.amount,
                        note: newVal.note
                    };
                } else {
                    this.resetForm();
                }
            }
        }
    },
    methods: {
        resetForm() {
            this.form = {
                expenseDate: "",
                reasonId: null,
                amount: null,
                note: ""
            };
        },
        save() {
            if (!this.form.expenseDate || !this.form.reasonId || !this.form.amount) {
                this.$message.warning("Zəhmət olmasa bütün sahələri doldurun.");
                return;
            }

            const d = this.form.expenseDate;
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            const formattedDate = `${yyyy}-${mm}-${dd}`;

            const payload = {
                expenseType: 1,
                courtCaseId: Number(this.courtCaseId),
                expenseDate: formattedDate,
                reasonId: this.form.reasonId,
                amount: this.form.amount,
                note: this.form.note,
                user: this.$store.state.user.id,
            };

            const request = this.expenseToEdit
                ? UpdateCourtExpense({ ...payload, id: this.expenseToEdit.id })
                : CreateCourtExpense(payload);

            request
                .then(() => {
                    this.$message.success("Uğurlu əməliyyat!");
                    this.resetForm();            
                    this.$emit("saved");        
                })
                .catch((error) => {
                    console.error("Server xətası:", error);
                    this.$message.error("Xəta baş verdi");
                });
        }

    }
};
</script>
